module.exports = __webpack_public_path__ + "static/media/kf-res-logo.a1b1c612.svg";